var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-divider'),_c('v-card-actions',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }